module.exports = __webpack_public_path__ + "static/media/keto-essence-package.ab2aadee.png";